import React, { useCallback } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import ResourceFiltersTag from './ResourceFiltersTag';

type Props = {
  label: string;
};

const ResourceFiltersTags: React.FC<Props> = ({ label }) => {
  const classes = useStyles();
  const [{ selectedFilters }, { setSelectedFilters }] = useResources();

  const handleOnDelete = useCallback(
    (tag) => setSelectedFilters(selectedFilters.filter((item) => item.id !== tag.id)),
    [selectedFilters]
  );

  return (
    <div className={classes.parentDiv}>
      <Typography variant="h4" className={classes.label}>
        {label}
      </Typography>
      <Breadcrumbs separator="" aria-label="breadcrumb">
        {selectedFilters.map((tag) => (
          <ResourceFiltersTag key={tag.id} tag={tag} onDelete={handleOnDelete} />
        ))}
      </Breadcrumbs>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  parentDiv: {
    backgroundColor: '#F4F4F4',
    display: 'flex',
    flex: 1,
    paddingTop: remCalc(20),
  },
  label: {
    margin: `0px ${remCalc(19.2)}`,
    whiteSpace: 'nowrap',
  },
}));

export default ResourceFiltersTags;
